import React, { useState, useEffect } from 'react';
import './Team.css';
import { getApiBaseUrl } from '../config/api';

export default function Team() {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/users`);
        const data = await response.json();
        if (Array.isArray(data)) {
          const filtered = data.filter(m => m.displayOnFrontend !== false);
          const sorted = filtered.sort((a, b) => (a.rank || 0) - (b.rank || 0));
          setTeam(sorted);
        } else {
          console.error('API returned non-array data:', data);
          setTeam([]);
        }
      } catch (err) {
        console.error('Error fetching team:', err);
        setTeam([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTeam();
  }, []);

  if (loading) {
    return (
      <section className="section shell" id="team">
        <p>Loading team...</p>
      </section>
    );
  }

  if (team.length === 0) {
    return (
      <section className="section shell" id="team">
        <p>No team members found.</p>
      </section>
    );
  }

  return (
    <section className="section shell" id="team" style={{ borderBottom: '1px solid rgba(244, 241, 234, 0.1)', paddingBottom: 'var(--spacing-4xl)' }}>
      <div className="cases-head" style={{ alignItems: 'center', marginBottom: 'var(--spacing-3xl)', marginTop: 0 }}>
        <div>
          <div className="section-label reveal">06 — Leadership</div>
          <h2 className="display cases-head__title reveal" style={{ marginTop: '32px' }}>
            Engineers<br /><em style={{ color: 'rgba(244, 241, 234, 0.5)' }}>at the front.</em>
          </h2>
        </div>
        <p className="cases-head__sub reveal" style={{ color: 'rgba(244, 241, 234, 0.65)', textAlign: 'center' }}>
          The partners are the practitioners. Every engagement is led by a named senior who is accountable from diligence to handover.
        </p>
      </div>

      <div className="team-grid">
        {team.map((member, idx) => (
          <div key={member._id} className="team-card reveal">
            <div className="team-card__photo">
              {member.avatar ? (
                <img src={member.avatar} alt={member.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <>
                  <div className="placeholder-stripes" style={{ position: 'absolute', inset: 0 }}></div>
                  <span className="placeholder-label">[ {member.name} ]</span>
                </>
              )}
            </div>
            <div>
              <div className="team-card__role">{member.position || member.role || 'Team Member'}</div>
              <h3 className="team-card__name" style={{ marginTop: '6px' }}>{member.name}</h3>
            </div>
            <p className="team-card__bio">{member.bio || member.email}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
